const orderDetail = {
  namespaced: true,
  state() {
    return {
      orderWidgetValue: {},
      orderWidgetStatus: 'closed',
      orderChangedColumns: [],
      orderScore: {},
    };
  },
  mutations: {
    set_value(state, payload) {
      state.orderWidgetValue = payload;
    },
    set_status(state, payload) {
      state.orderWidgetStatus = payload;
    },
    set_changed_columns(state, payload) {
      state.orderChangedColumns = payload;
    },
    set_score(state, payload) {
      state.orderScore = payload;
    },
  },

  actions: {
    orderWidgetSetValue({ commit }, payload) {
      commit('set_value', payload);
    },
    orderWidgetSetChangedColumns({ commit }, payload) {
      commit('set_changed_columns', payload);
    },
    orderWidgetSetStatus({ commit }, payload) {
      commit('set_status', payload);
    },
    orderWidgetSetScore({ commit }, payload) {
      commit('set_score', payload);
    },
  },

  getters: {
    orderWidgetValue: (state) => state.orderWidgetValue,
    orderWidgetStatus: (state) => state.orderWidgetStatus,
    orderChangedColumns: (state) => state.orderChangedColumns,
    orderScore: (state) => state.orderScore,
  },
};

export default {
  ...orderDetail
}
